import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import CTASection, { FAQSection } from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <PopularSection />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '国产视频精选平台——发现优质国内原创内容',
          description: '国产视频精选平台汇聚海量优质国内原创影视、短视频与纪录片内容，涵盖剧情、喜剧、科技、文化等多元类型。',
          url: 'https://guochanvideo.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '国产视频精选平台',
            url: 'https://guochanvideo.com/',
          },
        })}
      </script>
    </>
  );
}